import { type SalesPartnerMountRequest } from "../salesPartnerTypes";
import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/store-finder/basic-data");

export function getBasicSalesPartnerData(): Promise<SalesPartnerMountRequest> {
  return fetch(apiUrl, {
    method: "GET",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      dataType: "json",
      "content-type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json();
    }
  });
}
